import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { restRequest } from '../../../Helpers/RequestHelper';

import OverlayLoader from '../../../Components/Loader/OverlayLoader';
import Form from '../../../Components/Form/Form';
// import Field from '../../../Components/Form/Field/Field'
import FormAction from '../../../Components/Form/FormAction';
import { getObjFromLS } from '../../../Helpers/LocalStorage'; //, setObjInLS
import { checkError } from '../../../Helpers/AuthHelper';
import { t } from 'i18next';

class BillPreference extends Component {
  state = {
    loading: true,
    salesPref: {
      blFormat: '',
    },
    terms: '',
    isSubmitting: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    this.setState({ loading: true });
    await restRequest('get', 'numberPreferences/bill')
      .then((res) => {
        this.setState({
          salesPref: {
            blFormat: res.preferences.blFormat,
          },
          terms: res.terms,
        });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        this.setState({ loading: false });
      });
    this.setState({ loading: false });
  }

  toggleBillFormatChange(value) {
    let blAddedFormat = value.target.value;
    this.setState((state) => ({
      salesPref: {
        ...state.salesPref,
        blFormat: blAddedFormat,
      },
    }));
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let { blFormat } = this.state.salesPref;
    this.setState({ isSubmitting: true });
    restRequest('put', 'numberPreferences/bill', {
      status: {
        blFormat: blFormat,
      },
      terms: this.state.terms,
    })
      .then(() => {
        this.setState({ isSubmitting: false });
        this.props.handleToast(
          t('common.bill_prefix_preference_updated_successfully'),
          'success'
        );
      })
      .catch((error) => {
        this.setState({ isSubmitting: false });
        checkError(error, this.props.handleToast);
        //this.props.handleToast(error, "error")
      });
  };
  /*
  salesTermsContent() {
    return (
      <div>
        <Field
          name="Terms & Conditions"
          id="terms"
          type="textarea"
          value={this.state.terms}
          placeholder="Terms & Conditions"
          handleChange={this.handleChange}
        />
      </div>
    )
  }
*/
  renderActionButtons() {
    // return (
    //   <FormAction disabled={this.state.isSubmitting} onCancel={() => this.props.history.push('/settings')} />
    // )
    let permissions = getObjFromLS('role').permissions;
    if (!permissions.superAccess) {
      if (permissions.PreferenceEdit) {
        return (
          <FormAction
            disabled={this.state.isSubmitting}
            onCancel={() => this.props.history.push('/settings')}
          />
        );
      }
    }
    if (permissions.superAccess) {
      return (
        <FormAction
          disabled={this.state.isSubmitting}
          onCancel={() => this.props.history.push('/settings')}
        />
      );
    }
  }

  renderBillPreference() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="po-pref-component">
          {this.state.loading && <OverlayLoader />}
          <div>{t('common.change_bill_prefix_as_needed')}</div>
          {/*<hr className="pref--hr" />*/}
          <label className="list-table--checkbox-lable">
            <div className="sale-return-preference--label-text semi-bold">
              {t('common.bill_prefix')}
            </div>
            <input
              style={{ width: '50px' }}
              name="blFormat"
              value={this.state.salesPref.blFormat}
              type="text"
              //pattern='[0-9]{0,5}'
              maxLength={3}
              required
              onChange={(value) => this.toggleBillFormatChange(value)}
            />
          </label>
          {this.renderActionButtons()}
        </div>
      </Form>
    );
  }

  render() {
    return this.renderBillPreference();
  }
}

export default withRouter(BillPreference);
